import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { _t, locations, createLink } from 'utils';
import { ACTIONS_TYPES } from 'redux/helper';
import { ROUTE } from 'constant';
import { featuresToggle } from 'utils/features-toggle';
import Shared from 'screens/shared';
import NeedHelp from './need-help';
import useFilter from './hooks/filters';
import CreateForm from './create';
import Properties from './properties';

export default ({ history }) => {
  const [datacenters, filterForm] = useFilter();

  useEffect(() => {
    actions.contract.getAll();
    actions.dataCenter.getAll();
  }, []);

  return (
    <Shared.widgets.Page route={ROUTE.DASHBOARD.DATA_CENTERS} isStrap={false}>
      <Shared.widgets.Section
        sectionTitle={_t('Data Centers')}
        createForm={<CreateForm />}
        createActionType={ACTIONS_TYPES.DATA_CENTER.CREATE}
        setItemTitle={({ properties = {} }) => properties.name}
        filterRender={filterForm}
        items={datacenters}
        setItemKey={(e) => e.id}
        setItemDetails={({ properties = {} }) => locations[properties.location].name}
        setItemImage={({ properties = {} }) => locations[properties.location].image}
        itemIconColor="white"
        tableColumns={['', 'Name', 'Region']}
        itemOnClick={(e) => history.push(createLink(ROUTE.DASHBOARD.DATA_CENTER, { id: e?.id }))}
      />
      <div style={{ margin: '4px -8px' }}>
        <Properties />
        <NeedHelp />
        {featuresToggle.isAdServer() && <Shared.components.AdServer />}
      </div>
    </Shared.widgets.Page>
  );
};
